import React from 'react';
import './styles.css';

const Footer = () => {
  return (
    <div className='footer-container'>
      <p>Made with React.js, Tensorflow and Care</p>
    </div>
  );
}

export default Footer;